//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CincinattiStrokeScale_info",

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Neuro/CincinattiStrokeScale_info.vue